import { FieldMap, UiName } from "../../shared/types";
import { MaximaleHypotheek } from "../../.generated/forms/formstypes";
import { target2field } from "../../shared/utils/target-to-field";

export function mapDlTargetToMaximaleHypotheekUiField(target: string): UiName | null {
    const map: FieldMap<MaximaleHypotheek> = {};
  
    return target2field(map, target);
  }